var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ open }) {
              return [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c("span", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _c("v-fade-transition", [
                      open
                        ? _c(
                            "span",
                            { staticStyle: { display: "inline-flex" } },
                            [
                              _c("v-divider", {
                                staticClass: "mx-2",
                                attrs: { vertical: "" },
                              }),
                              _c(
                                "v-menu",
                                {
                                  attrs: {
                                    absolute: false,
                                    "close-on-click": true,
                                    "close-on-content-click": true,
                                    "offset-y": true,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on }) {
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "primary",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.row_create()
                                                    },
                                                  },
                                                },
                                                on
                                              ),
                                              [
                                                _vm._v(" Add "),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: { "x-small": "" },
                                                  },
                                                  [_vm._v("mdi-text-box")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                _vm._l(_vm.items, function (item, i) {
                                  return _c(
                                    "v-list",
                                    {
                                      key: i,
                                      staticClass: "pa-0",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-list-item",
                                        { attrs: { dense: "" } },
                                        [
                                          _c("v-list-item-title", {
                                            domProps: {
                                              textContent: _vm._s(
                                                item.platform.kind.key
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c("v-spacer"),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c("v-divider", { staticClass: "mb-2" }),
          _vm._l(_vm.items, function (item, i) {
            return _c(
              "v-chip",
              {
                key: i,
                staticClass: "ma-1",
                attrs: {
                  color: item.visible ? "green" : "blue darken-1",
                  outlined: !item.visible,
                  "text-color": item.visible ? "white" : "blue",
                  close: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.row_update(item)
                  },
                  "click:close": function ($event) {
                    return _vm.row_remove(item)
                  },
                },
              },
              [_vm._v(" " + _vm._s(item.platform.kind.key) + " ")]
            )
          }),
        ],
        2
      ),
      _c("r-trigger-wonder", { ref: "trigger" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }